import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import Duos from "@/game-lol/models/lol-champions-arena-duos.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function queryArenaStats() {
  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.ArenaChampionsDuosStats,
  );
}

export default function (path?: string[], options?: object) {
  return getData(
    queryArenaStats(),
    Duos,
    path || ["lol", "championsArenaDuosStats"],
    {
      ...(options || {}),
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 2 * 60 * 60 * 1000, // 2 hours
    },
  );
}
